import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  TextInput,
  Table,
  TableBody,
  TableCell,
  TableHeader,
  TableRow,
  Layer,
  Heading,
} from "grommet";
import axios from "axios"; // Import axios for making API calls
import { useParams } from "react-router-dom"; // To access group_id from the route
import API_URL from "../../config/config"; // Base API URL
import { useNavigate } from "react-router-dom";
import { LinkPrevious } from "grommet-icons";

export const ViewUsers = ({ groupName }) => {
  const [invitedUsers, setInvitedUsers] = useState([]); // State to hold users data
  const [error, setError] = useState(""); // State for error messages
  const { group_id } = useParams(); // Access group_id from the URL params
  const navigate = useNavigate();

  // Fetch the invited users from the API
  const fetchInvitedUsers = async () => {
    try {
      const response = await axios.get(
        `${API_URL}/manager/get_group_users/${group_id}`,
      );
      console.log("Response:", response);
      setInvitedUsers(response.data.users);
    } catch (error) {
      console.error("Error fetching users:", error);
      setError("Failed to fetch users. Please try again.");
    }
  };

  // Handle user deletion
  const handleDeleteUser = async (user_id) => {
    try {
      await axios.delete(
        `${API_URL}/manager/delete_group_user/${group_id}/${user_id}`,
      );
      // Update UI by filtering out the deleted user
      setInvitedUsers(invitedUsers.filter((user) => user.id !== user_id));
    } catch (error) {
      console.error("Error deleting user:", error);
      setError("Failed to delete user. Please try again.");
    }
  };

  // Fetch users on component mount
  useEffect(() => {
    fetchInvitedUsers();
  }, []);

  // Handle error display in a Layer
  if (error) {
    return (
      <Layer onEsc={() => setError("")} onClickOutside={() => setError("")}>
        <Box pad="medium" gap="medium">
          <Heading level="3" margin="none">
            Error
          </Heading>
          <p style={{ color: "red" }}>{error}</p>
          <Button label="Close" onClick={() => setError("")} />
        </Box>
      </Layer>
    );
  }

  return (
    <Box pad="medium" gap="medium">
      <Box
        // margin={{ horizontal: "medium", top: "small" }}
        direction="row"
        justify="between"
        align="begin"
      >
        <LinkPrevious size="large" onClick={() => navigate(-1)} color="brand" />
      </Box>
      {/* Group name header */}
      {/* <Heading level="2" margin="none">
        Group: {groupName}
      </Heading> */}

      {/* Table heading */}
      <Heading level="2" margin="none">
        Users
      </Heading>

      {/* Users Table */}
      <Table>
        <TableHeader>
          <TableRow>
            <TableCell scope="col" border="bottom">
              Email
            </TableCell>
            <TableCell scope="col" border="bottom">
              Status
            </TableCell>
            <TableCell scope="col" border="bottom">
              Actions
            </TableCell>
          </TableRow>
        </TableHeader>
        <TableBody>
          {invitedUsers.length === 0 ? (
            // Display message when there are no users
            <TableRow>
              <TableCell colSpan="3" align="center">
                No users invited yet
              </TableCell>
            </TableRow>
          ) : (
            // Map through the users and display each user in a row
            invitedUsers.map((user, index) => (
              <TableRow key={index}>
                <TableCell>{user.email}</TableCell>
                <TableCell>
                  {user.user_status === 0 ? "Invited" : "Accepted"}
                </TableCell>
                <TableCell>
                  <Button
                    label="Delete"
                    onClick={() => handleDeleteUser(user.id)}
                    color="status-critical"
                  />
                </TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </Box>
  );
};
